import { render } from "./ColorItem.vue?vue&type=template&id=b241d0ba"
import script from "./ColorItem.vue?vue&type=script&lang=js"
export * from "./ColorItem.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__